import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import {useTranslation} from '@malt/vue3-use';
    import Shapes from '@/profile-creation-wizard/common/ui/Shapes.vue';
    import FunnelHeader from '@/profile-creation-wizard/components/Header.vue';
    import {getBrandIllustration} from '@malt/asset-utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ExistingProfileJoiningMaltStrategy',
  emits: ["cancel"],
  setup(__props, { emit: __emit }) {

    const {msg} = useTranslation();
    const emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(FunnelHeader),
    _createVNode(_component_VJoyWrapper, {
      class: "existing-profile-joining-malt-strategy",
      "row-gap": "6",
      direction: "column",
      "no-margin": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "existing-profile-joining-malt-strategy__img",
          src: _unref(getBrandIllustration)('bust-digital-worker-woman.svg'),
          alt: "Malt"
        }, null, 8, _hoisted_2),
        _createElementVNode("h2", {
          class: "existing-profile-joining-malt-strategy__title",
          innerHTML: _unref(msg)('profile.creation.wizard.strategy.existing.profile.title')
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          class: "existing-profile-joining-malt-strategy__content",
          innerHTML: _unref(msg)('profile.creation.wizard.strategy.existing.profile.content')
        }, null, 8, _hoisted_4),
        _createVNode(_component_VJoyButton, {
          variant: "main",
          href: "mailto:support@malt.com"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.existing.profile.support')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_VJoyButton, {
      variant: "secondary",
      class: "existing-profile-joining-malt-strategy__back-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(msg)('generic.navigation.button.prev')), 1)
      ]),
      _: 1
    }),
    _createVNode(Shapes, { "is-malt-strategy": true })
  ]))
}
}

})